const PROFILE_STATUSES = {
    NONE: 'NONE',
    BAV: 'BAV',
    CREATE_ACCOUNT: 'CREATE_ACCOUNT',
    CARD_REQD: 'CARD_REQD',
    CHALLENGE: 'CHALLENGE',
    CHOICE_KBA_BAV: 'CHOICE_KBA_BAV',
    CREATE_ACCOUNT_FAIL: 'CREATE_ACCOUNT_FAIL',
    DOC_PENDING: 'DOC_PENDING',
    DOC_REJECTED: 'DOC_REJECTED',
    DOC_SECURITY: 'DOC_SECURITY',
    DOC_VERIFY: 'DOC_VERIFY',
    ERROR: 'ERROR',
    FAIL: 'FAIL',
    ID_CHECK: 'ID_CHECK',
    INCORRECT_PHONE_NUMBER: 'INCORRECT_PHONE_NUMBER',
    INCORRECT_EMAIL_ADDRESS: 'INCORRECT_EMAIL_ADDRESS',
    KBA: 'KBA',
    KBA_BLOCKED: 'KBA_BLOCKED',
    MISSING_ADDRESS: 'MISSING_ADDRESS',
    NO_FILE: 'NO_FILE',
    OTP: 'OTP',
    OTP_EMAIL: 'OTP_EMAIL',
    OTP_MASKED: 'OTP_MASKED',
    OTP_MASKED_EMAIL: 'OTP_MASKED_EMAIL',
    OTP_PHONE_OR_EMAIL: 'OTP_PHONE_OR_EMAIL',
    PASS: 'PASS',
    REVIEW_DVS: 'REVIEW_DVS',
    TEMP_NO_FILE: 'TEMP_NO_FILE',
    TEMP_PARTIAL_MATCH: 'TEMP_PARTIAL_MATCH',
    THIN_FILE: 'THIN_FILE',
    UNVERIFIED: 'UNVERIFIED',
    WAIT_72_HOURS: 'WAIT_72_HOURS',
    PASSED_DVS: 'PASSED_DVS',
};

const PROFILE_FAILURE_REASONS = {
    FAIL1: 'FAIL1',
    FAIL2: 'FAIL2',
    FAIL3: 'FAIL3',
    FAIL4: 'FAIL4',
    FAIL5: 'FAIL5',
    BAV_REQUIRED: 'BAV_REQUIRED',
    DOC_FILED_BAV: 'DOC_FILED_BAV',
    DOC_REQUIRED: 'DOC_REQUIRED',
    DOC_RESUBMIT: 'DOC_RESUBMIT',
    DOC_SUBMITTED: 'DOC_SUBMITTED',
    DOC_CIFAS: 'DOC_CIFAS',
    PARTIAL_MATCH_FAIL: 'PARTIAL_MATCH_FAIL',
    FRAUD_RISK: 'FRAUD_RISK',
    BAN: 'BAN',
    DVS_NO_MATCH: 'DVS_NO_MATCH',
};

const ACCOUNT_STATUSES = {
    BLOCKED: 'BLOCKED',
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
    PASS: 'PASS',
    TEMP_LOCKED: 'TEMP_LOCKED',
    LOCKED: 'LOCKED',
    DUP_LOCKED: 'DUP_LOCKED',
    SEC_LOCKED: 'SEC_LOCKED',
};

const RESUBMIT_STATUS = {
    idvStatus: PROFILE_STATUSES.THIN_FILE,
    idvReason: 'DOC_RESUBMIT',
};

const DOCUMENTS_UPLOAD_STATUSES = [PROFILE_STATUSES.DOC_VERIFY, PROFILE_STATUSES.DOC_PENDING];

const OPT_STATUSES = [
    PROFILE_STATUSES.ID_CHECK,
    PROFILE_STATUSES.OTP,
    PROFILE_STATUSES.OTP_MASKED,
    PROFILE_STATUSES.INCORRECT_PHONE_NUMBER,
];

const GB_PASS_STATUSES = [PROFILE_STATUSES.PASS, PROFILE_STATUSES.NO_FILE];

const GB_REGISTRATION_STATUSES = [
    PROFILE_STATUSES.CREATE_ACCOUNT,
    PROFILE_STATUSES.CREATE_ACCOUNT_FAIL,
    PROFILE_STATUSES.FAIL,
    PROFILE_STATUSES.MISSING_ADDRESS,
    PROFILE_STATUSES.ID_CHECK,
    PROFILE_STATUSES.UNVERIFIED,
    PROFILE_STATUSES.KBA,
    PROFILE_STATUSES.DOC_VERIFY,
    PROFILE_STATUSES.DOC_PENDING,
    PROFILE_STATUSES.THIN_FILE,
    PROFILE_STATUSES.CHOICE_KBA_BAV,
    PROFILE_STATUSES.TEMP_NO_FILE,
    PROFILE_STATUSES.TEMP_PARTIAL_MATCH,
    PROFILE_STATUSES.BAV,
    PROFILE_STATUSES.DOC_REJECTED,
    PROFILE_STATUSES.DOC_SECURITY,
    PROFILE_STATUSES.WAIT_72_HOURS,
];

const EMPLOYMENT_STATUSES = {
    SALARIED: 'SALARIED',
    SELF_EMPLOYED_BUSINESS: 'SELF_EMPLOYED_BUSINESS',
    SELF_EMPLOYED_PROFESSIONAL: 'SELF_EMPLOYED_PROFESSIONAL',
    STUDENT: 'STUDENT',
    RETIRED: 'RETIRED',
    UNEMPLOYED: 'UNEMPLOYED',
    FT_EMPLOYED: 'FT_EMPLOYED',
    PT_EMPLOYED: 'PT_EMPLOYED',
    WORK_AT_HOME: 'WORK_AT_HOME',
    SELF_EMPLOYED: 'SELF_EMPLOYED',
};

const RESIDENTIAL_STATUSES = {
    HOMEOWNER: 'HOMEOWNER',
    PRIVATE_TENANT: 'PRIVATE_TENANT',
    COUNCIL_TENANT: 'COUNCIL_TENANT',
    WITH_PARENTS: 'WITH_PARENTS',
    RDP_TENANT: 'RDP_TENANT',
};

exports.PROFILE_STATUSES = PROFILE_STATUSES;
exports.PROFILE_FAILURE_REASONS = PROFILE_FAILURE_REASONS;
exports.ACCOUNT_STATUSES = ACCOUNT_STATUSES;
exports.RESUBMIT_STATUS = RESUBMIT_STATUS;
exports.DOCUMENTS_UPLOAD_STATUSES = DOCUMENTS_UPLOAD_STATUSES;
exports.OPT_STATUSES = OPT_STATUSES;
exports.GB_PASS_STATUSES = GB_PASS_STATUSES;
exports.GB_REGISTRATION_STATUSES = GB_REGISTRATION_STATUSES;
exports.EMPLOYMENT_STATUSES = EMPLOYMENT_STATUSES;
exports.RESIDENTIAL_STATUSES = RESIDENTIAL_STATUSES;
